module.exports = __webpack_public_path__ + "static/media/faint.8ecf3f5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Page404/faint.svg
// module id = 659
// module chunks = 0